module.exports = __webpack_public_path__ + "img/vip-2.d96e5429.png";